import { ResultOf } from "gql.tada";
import { GetArticlePageBySlug } from "@queries/GetArticlePageBySlug";
import { MetadataHelmet } from "./MetadataHelmet";
import { BackgroundBlob } from "./BackgroundBlob";
import { RichText } from "./core/RichText";
import { BLOCKS } from "@contentful/rich-text-types";
import { MediaItem } from "./MediaItem";
import { useScrollReset } from "@hooks/useScrollReset";

export const ArticlePage = ({
  articlePage,
}: {
  articlePage: NonNullable<
    NonNullable<
      ResultOf<typeof GetArticlePageBySlug>["articlePageCollection"]
    >["items"][number]
  >;
}) => {
  useScrollReset();

  return (
    <>
      <MetadataHelmet pageInfo={{ slug: articlePage.slug, metadata: articlePage.metadata }} />
      <section className="mb-20 mt-20 relative">
        <BackgroundBlob />
        <div className="flex flex-col container-base dsk:grid-base">
          <div className="col-start-2 col-span-8">
            <div className="dsk:sticky top-16">
              <div className="text-heading-2">{articlePage.title}</div>
              <div className="text-body-regular my-10">
                {articlePage.subtitle}
              </div>
            </div>
          </div>
          <div className="col-start-12 col-end-24">
            {articlePage.heroImage && (
              <MediaItem
                className="rounded-xl"
                item={articlePage.heroImage}
                controls
                muted={false}
                autoPlay={false}
              />
            )}
            <RichText
              body={articlePage.body}
              options={{
                renderNode: {
                  [BLOCKS.PARAGRAPH]: (_, children) => (
                    <p className="text-body-regular [*+&]:mt-5 font-normal">
                      {children}
                    </p>
                  ),
                },
              }}
            />
          </div>
        </div>
      </section>
    </>
  );
};
